import { render, staticRenderFns } from "./AutoInvoiceStamped.vue?vue&type=template&id=35ff032a&scoped=true&"
import script from "./AutoInvoiceStamped.vue?vue&type=script&lang=js&"
export * from "./AutoInvoiceStamped.vue?vue&type=script&lang=js&"
import style0 from "./AutoInvoiceStamped.vue?vue&type=style&index=0&id=35ff032a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ff032a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ff032a')) {
      api.createRecord('35ff032a', component.options)
    } else {
      api.reload('35ff032a', component.options)
    }
    module.hot.accept("./AutoInvoiceStamped.vue?vue&type=template&id=35ff032a&scoped=true&", function () {
      api.rerender('35ff032a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Customer/AutoInvoiceStamped.vue"
export default component.exports